import { type MessageDescriptor } from 'react-intl-next';
import { type BlueprintModuleCompleteKey } from '../../common/types';

export enum TemplateType {
	Confluence,
	Link,
}

interface TemplatePreviewThemes {
	dark?: string;
	default: string;
}

export interface TemplateBase {
	key: string;
	iconRender: ({ size, color }: { size: 'small' | 'medium'; color: string }) => React.ReactNode;
	defaultIconColor: string;
}
interface TemplateCommon extends TemplateBase {
	type: TemplateType;
	name: MessageDescriptor;
	description?: MessageDescriptor;
	tooltip?: MessageDescriptor;
	title?: MessageDescriptor;
	content?: string;
}
export interface ConfluenceTemplate extends TemplateCommon {
	type: TemplateType.Confluence;
	blueprintModuleCompleteKey: BlueprintModuleCompleteKey;
	getTitle?: () => string;
	preview: {
		preExpand: TemplatePreviewThemes;
		postExpand: TemplatePreviewThemes;
	};
}

export interface LinkTemplate extends TemplateCommon {
	type: TemplateType.Link;
	url: string;
	renderShortcutIcon: boolean;
}

export type Template = ConfluenceTemplate | LinkTemplate;
